var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCobrancasNewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 897"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9677 7.22223H11.3632C10.7936 7.22223 10.332 7.68387 10.332 8.25334V19.9689C10.332 20.5384 10.7936 21 11.3632 21H19.9677C20.5373 21 20.9989 20.5384 20.9989 19.9689V8.25334C20.9989 7.68387 20.5373 7.22223 19.9677 7.22223Z",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.7865 15.4444C13.6024 15.4444 13.4531 15.2952 13.4531 15.1111C13.4531 14.927 13.6024 14.7778 13.7865 14.7778",
    stroke: "#737D8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.7871 15.4444C13.9712 15.4444 14.1204 15.2952 14.1204 15.1111C14.1204 14.927 13.9712 14.7778 13.7871 14.7778",
    stroke: "#737D8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.7865 18.5642C13.6024 18.5642 13.4531 18.415 13.4531 18.2309C13.4531 18.0468 13.6024 17.8976 13.7865 17.8976",
    stroke: "#737D8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.7871 18.5642C13.9712 18.5642 14.1204 18.415 14.1204 18.2309C14.1204 18.0468 13.9712 17.8976 13.7871 17.8976",
    stroke: "#737D8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.556 15.4444C17.3719 15.4444 17.2227 15.2952 17.2227 15.1111C17.2227 14.927 17.3719 14.7778 17.556 14.7778",
    stroke: "#737D8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.5566 15.4444C17.7407 15.4444 17.89 15.2952 17.89 15.1111C17.89 14.927 17.7407 14.7778 17.5566 14.7778",
    stroke: "#737D8C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.556 18.5642C17.3719 18.5642 17.2227 18.415 17.2227 18.2309C17.2227 18.0468 17.3719 17.8976 17.556 17.8976",
    stroke: "#737D8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M17.5566 18.5643C17.7407 18.5643 17.89 18.4151 17.89 18.231C17.89 18.0469 17.7407 17.8977 17.5566 17.8977",
    stroke: "#737D8C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M4.00131 4.33329C3.81721 4.33329 3.66797 4.18406 3.66797 3.99996C3.66797 3.81586 3.81721 3.66663 4.00131 3.66663",
    stroke: "#737D8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M4 4.33329C4.1841 4.33329 4.33334 4.18406 4.33334 3.99996C4.33334 3.81586 4.1841 3.66663 4 3.66663",
    stroke: "#737D8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M7.66677 11.6667H2.33335C1.97973 11.6667 1.64058 11.5262 1.39053 11.2762C1.14048 11.0261 1 10.6869 1 10.3333V2.33333C1 1.97972 1.14048 1.64057 1.39053 1.39052C1.64058 1.14048 1.97973 1 2.33335 1H17.0003C17.3539 1 17.6931 1.14048 17.9431 1.39052C18.1932 1.64057 18.3336 1.97972 18.3336 2.33333V4.55555",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M7.35556 7.67545C7.12404 7.26587 7.00161 6.8037 7 6.33322C6.99964 5.78678 7.16717 5.25341 7.4799 4.8053C7.79264 4.3572 8.23551 4.01599 8.74854 3.82785C9.26155 3.6397 9.82005 3.6137 10.3483 3.75338C10.8767 3.89306 11.3493 4.19166 11.7023 4.60878",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M10.332 12.1111H20.9989",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCobrancasNewIcon);
export default __webpack_public_path__ + "static/media/cobrancas-new-icon.eb44827af995e2180642654faee8a4eb.svg";
export { ForwardRef as ReactComponent };